export default __webpack_public_path__ + "static/proposal-no-permissions-ilustration-810671e1ae1293744199f9fe932756af.svg";